import { ProductGroupPipe } from './product.group.pipe';

export function ProductGroupFilter ( productGroupPipe : ProductGroupPipe ) {
  return ( value : string ) : string => productGroupPipe.transform(value);
}
